import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";

import {UserContext, user} from '../contexts/user-context';

import UserService from "../services/user-service";
import Helper from "../utils/helper";

import Header from '../components/Header';
import Layout from '../components/Layout';
import UserCheckEmailComponent from "../components/UserCheckEmailComponent";
import UserSignInComponent from "../components/UserSignInComponent";
import UserLogoutComponent from "../components/UserLogoutComponent";
import UserVerifyCodeComponent from "../components/UserVerifyCodeComponent";
import UserForgotPasswordComponent from "../components/UserForgotPasswordComponent";
import UserNewPasswordComponent from "../components/UserNewPasswordComponent";
import AfterResetPasswordComponent from "../components/AfterResetPasswordComponent";
import UserSignUpComponent from "../components/UserSignUpComponent";
import LanguageSwitch from '../components/LanguageSwitch';
import AuthorizeComponent from '../components/AuthorizeComponent';
import GeneralErrorComponent from '../components/GeneralErrorComponent';
import OutlookComponent from "../components/OutlookComponent";
import OutlookVerifyCodeComponent from "../components/OutlookVerifyCodeComponent";
import UserEnableOTP from '../components/UserEnableOTP';

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: user,
      errors: [],
      sso_providers: [],
      companyCodeRequired: false,
      checkUserEmail: this.checkUserEmail,
      login: this.login,
      confirmCode: this.confirmCode,
      loginSso: this.loginSso,
      signUp: this.signUp,
      forgotPassword: this.forgotPassword,
      updatePassword: this.updatePassword,
      authenticate: this.authenticate,
      confirmOTP: this.confirmOTP,
      serverError: false
    };

    UserService.checkSession().then(resp =>{
      this.setState(state => ({
        user: {
          ...state.user,
          email: Helper.isEmpty(resp.data.email) ? state.email : resp.data.email,
          app: resp.data.app,
          outlook: resp.data.outlook
        },
        sso_providers: resp.data.sso_providers,
        use_old_oauth_flow: resp.data.use_old_oauth_flow,
        old_oauth_flow_link: resp.data.old_oauth_flow_link,
        allow_username_password: resp.data.allow_username_password
      }));
    })
  }

  checkUserEmail = (email, inOutlook, outlookToken) => {
    this.setState(state => ({
      serverError: false,
      errors: []
    }));

    UserService.checkUserEmail(email, inOutlook, outlookToken).then(res =>{
      if (res.status == 400 || res.status == 401) {
        this.setState(state => ({
          errors: res.data.errors
        }));
      }
      if (res.status == 302){
        window.location = res.data.url
      }
    }).catch(ex => {
      this.setState(state => ({
        serverError: true
      }));
      console.error(ex)
    })
  };

  login = (email, password, otp_attempt) => {
    this.setState(state => ({
      serverError: false,
      errors: []
    }));

    UserService.login(email, password, otp_attempt).then(res =>{
      if (res.status == 302){
        window.location = res.data.url
      }
      if (res.status == 400 || res.status == 401) {
         if (res.data.errors.init_otp){
          // yuk, external routing
          // but makes the otp-page reloadable 
          window.location='/users/enable_otp';
        } else {
          this.setState(state => ({
            errors: res.data.errors
          }));
        }
      }
    }).catch(ex => {
      this.setState(state => ({
        serverError: true
      }));
    })
  }

  confirmCode = (confirmationCode, email, inOutlook) => {
    this.setState(state => ({
      serverError: false,
      errors: []
    }));

    UserService.confirmCode(confirmationCode, email, inOutlook).then(res =>{
      if (res.status == 302){
        window.location = res.data.url
      }
      if (res.status == 400 || res.status == 401) {
        this.setState(state => ({
          errors: res.data.errors
        }));
      }
    }).catch(ex => {
      this.setState(state => ({
        serverError: true
      }));
    })
  }

  loginSso = (sso_url) => {
    this.setState(state => ({
      serverError: false,
      errors: []
    }));

    window.location = sso_url
  }

  forgotPassword = (email) => {
    this.setState(state => ({
      serverError: false,
      errors: []
    }));

    UserService.forgotPassword(email).then(res =>{
      if (res.status == 302){
        window.location = res.data.url
      }
      if (res.status == 400 || res.status == 401) {
        this.setState(state => ({
          errors: res.data.errors
        }));
      }
    }).catch(ex => {
      this.setState(state => ({
        serverError: true
      }));
    })
  }

  updatePassword = (password, confirmPassword, resetPasswordToken) => {
    this.setState(state => ({
      serverError: false,
      errors: []
    }));

    UserService.updatePassword(password, confirmPassword, resetPasswordToken).then(res =>{
      if (res.status == 302){
        window.location = res.data.url
      }
      if (res.status == 400 || res.status == 401) {
        this.setState(state => ({
          errors: res.data.errors
        }));
      }
    }).catch(ex => {
      this.setState(state => ({
        serverError: true
      }));
    })
  }

  signUp = (params) => {
    this.setState(state => ({
      serverError: false,
      errors: []
    }));

    UserService.signUp(params).then(res =>{
      if (res.status == 302){
        window.location = res.data.url
      }
      if (res.status == 400){
        this.setState(state => ({
          errors: res.data.errors,
          companyCodeRequired: res.data.companyCodeRequired
        }));
      }
    }).catch(ex => {
      this.setState(state => ({
        serverError: true
      }));
    })
  };

  authenticate = (params) => {
    this.setState(state => ({
      serverError: false,
      errors: []
    }));

    UserService.authenticate(params).then(res =>{
      if (res.status == 302){
        window.location = res.data.url
      }
      else if (res.status == 400){
        this.setState(state => ({
          errors: res.data.errors,
          companyCodeRequired: res.data.companyCodeRequired
        }));
      }
      else {
        window.location = '/'
      }
    }).catch(ex => {
      this.setState(state => ({
        serverError: true
      }));
    })
  };

  confirmOTP = (params) => {
    this.setState(state => ({
      serverError: false,
      errors: []
    }));

    UserService.confirmOTP(params).then(res =>{
      if (res.status == 302){
        window.location = res.data.url
      }
      else if (res.status == 400){
        this.setState(state => ({
          errors: res.data.errors,
        }));
      }
      else {
        console.log('unexpected result', res)
        window.location = '/'
      }
    }).catch(ex => {
      this.setState(state => ({
        serverError: true
      }));
    })
  };

  render() {
    return (
      <UserContext.Provider value={this.state}>
        {/* <Header /> */}
        <Layout>
          <Router>
            <Routes>
              <Route path="/outlook/index" element={<OutlookComponent />}>
              </Route>
              <Route path="/outlook/verify_code" element={<OutlookVerifyCodeComponent />}>
              </Route>
              <Route path="/oauth/authorize" element={<AuthorizeComponent />}>
              </Route>
              <Route path="/users/password/reset" element={<AfterResetPasswordComponent />}>
              </Route>
              <Route path="/users/enable_otp" element={<UserEnableOTP />}>
              </Route>
              <Route path="/users/password/edit" element={<UserNewPasswordComponent />}>
              </Route>
              <Route path="/users/sign_up" element={<UserSignUpComponent />}>
              </Route>
              <Route path="/users/sign_in" element={<UserSignInComponent />}>
              </Route>
              <Route path="/signout" element={<UserLogoutComponent />}>
              </Route>
              <Route path="/verify_code" element={<UserVerifyCodeComponent />}>
              </Route>
            <Route path="/users/password/new" element={<UserForgotPasswordComponent />}>
              </Route>
              <Route path="/error" element={<GeneralErrorComponent />}>
              </Route>
              <Route path="/" element={<UserCheckEmailComponent />}>
              </Route>
            </Routes>
          </Router>
          <div className="row justify-content-center">
            <LanguageSwitch />
          </div>
        </Layout>
        {this.state.serverError &&
          <GeneralErrorComponent />
        }
      </UserContext.Provider>
    );
  }
}

export default App;
